import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useWorkspaceAccountMutations from "common/datahooks/useWorkspaceAccountMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface DeleteAccountProps {
  accountId: string;
  accountFullname: string;
  goBack: () => void;
  onSuccess: () => void;
}

export default function DeleteAccount({
  accountId,
  accountFullname,
  goBack,
  onSuccess,
}: DeleteAccountProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { deleteAccount, isDeletingAccount } = useWorkspaceAccountMutations();

  function onClick() {
    deleteAccount({ accountId }).then(onSuccess);
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title={`Delete "${accountFullname}"?`}
        subtitle="This will permanently remove this LinkedIn account from your workspace, and you will lose access to all of their leads, campaigns and conversations"
      />
      <Footer className="justify-end">
        <Button
          onClick={goBack}
          variant="secondary-black"
          disabled={isDeletingAccount}
        >
          Cancel
        </Button>
        <Button
          isLoading={isDeletingAccount}
          onClick={onClick}
          variant="outline-danger"
        >
          Delete account
        </Button>
      </Footer>
    </>
  );
}
